(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["funcinating-discount-claim"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-discount-claim]');
    if (!root) return;

    const params = new URLSearchParams(window.location.search);
    const parameterNames = ['coupon', 'discount_code', 'discount', 'code'];
    const matchedName = parameterNames.find((name) => params.get(name));
    const rawCode = matchedName ? params.get(matchedName) : getCookieValue('discount_code');
    const code = rawCode ? rawCode.trim().replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 48) : '';

    if (!code) return;

    const message = root.dataset.message || 'Your discount is ready and will be applied at checkout when eligible.';
    const ctaLabel = root.dataset.ctaLabel || 'Shop Now';
    const shopUrl = root.dataset.shopUrl || '/collections/all';
    let isClosing = false;

    root.querySelector('[data-discount-claim-message]').textContent = message;

    const cta = root.querySelector('[data-discount-claim-cta]');
    cta.textContent = ctaLabel;
    cta.href = shopUrl;

    root.hidden = false;
    removeCouponParameters(params, parameterNames);
    clearCookie('discount_code');

    root.querySelectorAll('[data-discount-claim-close]').forEach((closeButton) => {
      closeButton.addEventListener('click', () => {
        hideClaim();
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') hideClaim();
    });

    function hideClaim() {
      if (isClosing) return;
      isClosing = true;
      root.classList.add('is-hiding');
      window.setTimeout(() => {
        root.hidden = true;
        root.classList.remove('is-hiding');
      }, 200);
    }

    function getCookieValue(name) {
      const cookie = document.cookie
        .split(';')
        .map((part) => part.trim())
        .find((part) => part.startsWith(`${name}=`));

      if (!cookie) return '';

      return decodeURIComponent(cookie.split('=').slice(1).join('='));
    }

    function clearCookie(name) {
      const expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
      document.cookie = `${name}=; expires=${expires}; path=/; SameSite=Lax`;
      document.cookie = `${name}=; expires=${expires}; path=${window.location.pathname}; SameSite=Lax`;
    }

    function removeCouponParameters(searchParams, names) {
      let changed = false;
      names.forEach((name) => {
        if (searchParams.has(name)) {
          searchParams.delete(name);
          changed = true;
        }
      });

      if (!changed || !window.history?.replaceState) return;

      const nextSearch = searchParams.toString();
      const nextUrl = `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ''}${window.location.hash}`;
      window.history.replaceState({}, '', nextUrl);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
